export enum CacheInternal {
  CACHE_API = "edtell-cache-api",
  CLASS_CACHE_API = "edtell-class-cache-api",
  INSTANCE_CACHE = "_EDTELL_CACHE_INSTANCE",
}
